/* global window */
import * as React from 'react';
import { connect } from 'react-redux';
import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';

import { createPaymentSession, createAdyenDropInConfiguration, saveSuccessfulCardPayment } from '../../../services/payment/AdyenPaymentService';

import OverlayLoader from '../../../parts/OverlayLoader';
import FailureOverlay from '../../../parts/FailureOverlay';

const CARD_ERROR_MESSAGE = "Your payment failed. Please check your payment details and try again. If the problem persists, please try a different payment card or method, or call us on 0800 140 40 40 and we'll be happy to help.";
const SAVE_SUCCESSFUL_PAYMENT_ERROR_MESSAGE = "Thank you for your payment! We've encountered problems with transaction processing. Please call us on 0800 1404040 and we will be happy to help";

const ComponentModes = {
    LoadPaymentSessionInProgress: 'LoadPaymentSessionInProgress',
    LoadPaymentSessionSuccess: 'LoadPaymentSessionSuccess',
    LoadPaymentSessionFailed: 'LoadPaymentSessionFailed',
    PaymentFailed: 'PaymentFailed',
    SavePaymentResultInProgress: 'SavePaymentResultInProgress',
    SavePaymentResultFailed: 'SavePaymentResultFailed',
    SavePaymentResultSuccess: 'SavePaymentResultSuccess'
};

class AdyenPaymentPanel extends React.Component {
    adyenContainerRef = React.createRef();
    checkout = null;

    constructor(props) {
        super(props);
        this.state = {
            componentMode: ComponentModes.LoadPaymentSessionInProgress,
            paymentError: null
        };
    }

    componentDidMount() {
        this.initAdyenComponent();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.loadingAmount && !this.props.loadingAmount && this.state.componentMode !== ComponentModes.LoadPaymentSessionInProgress) {
            this.initAdyenComponent();
        }
    }

    initAdyenComponent() {
        const { isSofologist, userGuid, orderRef, orderNo, amount } = this.props;
        this.setState({ componentMode: ComponentModes.LoadPaymentSessionInProgress });

        createPaymentSession(isSofologist, userGuid, orderRef, orderNo, amount)
            .then((paymentSession) => {
                const configuration = createAdyenDropInConfiguration(paymentSession, this.handlePaymentSuccess, this.handlePaymentError, this.handleOnFocus);

                return AdyenCheckout(configuration);
            })
            .then((checkout) => {
                this.setState({ componentMode: ComponentModes.LoadPaymentSessionSuccess }, () => {
                    if (!this.adyenContainerRef.current) return;

                    this.checkout = checkout;
                    this.checkout.create('dropin').mount(this.adyenContainerRef.current);
                });
            })
            .catch(() => {
                this.setState({ componentMode: ComponentModes.LoadPaymentSessionFailed });
            });
    }

    handlePaymentSuccess = (vendorTxCode) => {
        const { userGuid, orderIdx, amount, orderData } = this.props;

        this.setState({ componentMode: ComponentModes.SavePaymentResultInProgress });

        saveSuccessfulCardPayment(userGuid, orderIdx, amount, vendorTxCode, orderData)
            .then(() => {
                this.setState({ componentMode: ComponentModes.SavePaymentResultSuccess });
                this.props.onComplete();
            })
            .catch(() => {
                this.setState({ componentMode: ComponentModes.SavePaymentResultFailed });
            });
    }

    handlePaymentError = () => {
        this.setState({ paymentError: CARD_ERROR_MESSAGE, componentMode: ComponentModes.PaymentFailed }, () => {
            this.initAdyenComponent();
        });
    }

    handleOnFocus = () => {
        if (this.state.paymentError) {
            this.setState({ paymentError: null })
        }
    }

    render() {
        const { componentMode, paymentError } = this.state;

        if (componentMode === ComponentModes.LoadPaymentSessionInProgress || componentMode === ComponentModes.SavePaymentResultInProgress || this.props.loadingAmount) {
            return this.renderSessionLoader();
        }

        if (componentMode === ComponentModes.LoadPaymentSessionFailed) {
            return this.renderDefaultError();
        }

        if (componentMode === ComponentModes.SavePaymentResultFailed) {
            return this.renderErrorMessage(SAVE_SUCCESSFUL_PAYMENT_ERROR_MESSAGE)
        }

        if (componentMode === ComponentModes.LoadPaymentSessionSuccess) {
            return (
                <div className="adyen-payment" >
                    {paymentError && this.renderErrorMessage(paymentError)}
                    {componentMode === ComponentModes.LoadPaymentSessionSuccess && <div ref={this.adyenContainerRef}></div>}
                </div >
            );
        }

        return null;
    }

    renderSessionLoader() {
        return (
            <div className="u-position-relative u-padding-y-large" >
                <OverlayLoader scale={0.5} active={true} background="white" />
            </div>
        );
    }

    renderDefaultError() {
        return (
            <div className="u-position-relative u-padding-y-large" >
                <FailureOverlay background="white" />
            </div>
        );
    }

    renderErrorMessage(errorMessage) {
        return (
            <div className="adyen-payment__error-message u-padding-bottom-small">{errorMessage}</div>
        );
    }
}

const mapStateToProps = state => ({
    isSofologist: state.sofologist.Authorized
});

export default connect(mapStateToProps, null)(AdyenPaymentPanel);


// WEBPACK FOOTER //
// ./src/cards/templates/payBalanceSections/AdyenPaymentPanel.js